import { getData, postData } from 'helpers/apiHelper';
import { AUDIT_LOGS, AUDIT_LOGS_EVENT_TYPES, AUDIT_LOGS_FIND_USERS, MAIN_PATH } from './apiPath';
import { pickBy } from "lodash";

export function getAuditLogsList(params, filters) {
  const queryString = new URLSearchParams(pickBy(params)).toString();
  let url = `${MAIN_PATH}${AUDIT_LOGS}?${queryString}`;
  // let url = `http://localhost:3000/STAGING/audit-logs?${queryString}`;
  return postData(url, {
    advanced_filters: filters
  }, {
    suppressSuccessMsg: true
  });
}

export function getEventTypesList(params, filters) {
  let url = `${MAIN_PATH}${AUDIT_LOGS_EVENT_TYPES}`;
  // let url = `http://localhost:3000/STAGING/audit-logs?${queryString}`;
  return getData(url);
}

export function getUsersList(params) {
  const query = new URLSearchParams(params).toString();
  let url = `${MAIN_PATH}${AUDIT_LOGS_FIND_USERS}?${query}`;
  // let url = `http://localhost:3000/STAGING/audit-logs?${queryString}`;
  return getData(url);
}